function MyvercoFaqsController(){
	this.className			= "MyvercoFaqsController";
	this.view				= false;
	this.glob				= ["/*/myverco/faqs**", "/*/myverco/faqs?**"];
	// this.glob			= ["/", "/?**"];
	this.viewData			= {};
}
MyvercoFaqsController.inheritsFrom( StandardController );
MyvercoFaqsController.prototype.swap = function(onComplete){
	this.$body				= $('body');
	this.$page				= this.$body.find('.js-page');
	this.$header			= this.$body.find('.js-page-header');
	this.$faq 				= this.$page.find('.js-faq');
	this.faq 				= document.querySelectorAll('.js-faq');

	return true;
}
MyvercoFaqsController.prototype.on = function(){

	this.$faq.find('.js-faq--header').on('click', (e) => {
		// this.faq.forEach(element => {
		// 	console.log(element);
		// 	this.faqToggle(element, true);
		// });
		const parent = e.currentTarget.closest('.js-faq');
		this.faqToggle(parent);
	});
}
MyvercoFaqsController.prototype.faqToggle = function(element, force= false){
	const content = element.querySelector('.js-faq--content');
	const contentHeight = content.clientHeight;
	const isOpen = contentHeight <= 0;

	let animateHeight = isOpen ? content.scrollHeight : 0;

	element.classList.toggle('open', isOpen);

	// if(force) animateHeight = 0;

	$(content).animate({ height: animateHeight }, 300, function() {
		if(!animateHeight) $(this).css('height', '');
	});
}
MyvercoFaqsController.prototype.off = function(){

}